/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:07.075
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listCardOperationLog,
	listCardOperationLogInit,
	listCardOperationLogByAuthorizations,
	deleteCardOperationLog
} from '@api/rentmanage/CardOperationLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listCardOperationLog({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCardOperationLog(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCardOperationLogByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCardOperationLogByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCardOperationLogInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCardOperationLogInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCardOperationLog({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCardOperationLog({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
